import { Link } from "react-router-dom";

export default function Footer() {
  const handleNewsletterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const email = formData.get("email") as string;

    if (!email || !email.includes("@")) {
      return;
    }

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://readdy.ai/api/form/d8rnvmte8ise6dlc8lr0", true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onload = () => {
      const input = form.querySelector("input") as HTMLInputElement;
      const btn = form.querySelector("button") as HTMLButtonElement;
      if (input) {
        input.value = "";
        input.placeholder = "Dziękujemy za zapis!";
      }
      if (btn) {
        btn.disabled = true;
      }
    };
    const params = new URLSearchParams();
    params.append("email", email);
    xhr.send(params.toString());
  };

  return (
    <footer className="bg-primary-900 text-background-100" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="inline-block text-2xl font-heading font-bold text-white hover:text-accent-400 transition-colors"
            >
              kakobuy<span className="text-accent-500">.gay</span>
            </Link>
            <p className="mt-4 text-sm text-background-300/80 leading-relaxed">
              Najlepszy polski katalog produktów Kakobuy. Aktualizowany codziennie, stworzony dla polskiej społeczności zakupowej.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-5">
              Newsletter
            </h4>
            <form
              data-readdy-form=""
              onSubmit={handleNewsletterSubmit}
              className="relative"
            >
              <input
                type="email"
                name="email"
                placeholder="Twój email"
                required
                className="w-full bg-transparent border-b border-background-500/40 py-3 pr-10 text-sm text-white placeholder:text-background-400 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-background-300 hover:text-accent-400 transition-colors"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </form>
            <p className="mt-2 text-xs text-background-500/60">
              Bądź na bieżąco z nowościami. Zero spamu.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-5">
              Kategorie
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com/category-911-Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  Buty
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  Bluzy i Swetry
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/category-913-T-Shirts.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  T-Shirty
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-5">
              Przydatne Linki
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  Strona Główna
                </Link>
              </li>
              <li>
                <Link
                  to="/artykul/najlepszy-kakobuy-spreadsheet-2026"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  Poradnik Kakobuy
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  Główna Strona Sklepu
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-500/20">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500/60">
              &copy; 2026 kakobuy.gay - Niezależny portal społeczności Kakobuy. Wszelkie prawa zastrzeżone.
            </p>
            <p className="text-xs text-background-500/60">
              Autor: Zespół Kakobuy Polska &bull; Ostatnia aktualizacja: Czerwiec 2026
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}